/* Gadea Loreak — "Nuestros clientes": tap-to-play de reels en la propia tarjeta.
   El póster (imagen real del reel) se muestra por defecto; al tocar se inyecta un
   <video> con sonido que ocupa la tarjeta. El vídeo NO se descarga hasta el tap
   (preload="none") → la home carga ligera. Solo un reel suena a la vez. */
(function () {
  'use strict';

  // Se carga en la home (Nuestros clientes) y en la PDP (Mundo Gadea):
  // guard para no duplicar el listener delegado si ambas coinciden.
  if (window.__iuropReelsLoaded) return;
  window.__iuropReelsLoaded = true;

  function pauseOthers(except) {
    document.querySelectorAll('.gl-clients__video').forEach(function (v) {
      if (v !== except) {
        v.pause();
        var media = v.closest('.gl-clients__media');
        if (media) media.classList.remove('is-playing');
      }
    });
  }

  function play(btn) {
    var src = btn.getAttribute('data-reel-src');
    if (!src) return;
    // ¿ya tiene vídeo montado? → alterna play/pausa
    var existing = btn.querySelector('.gl-clients__video');
    if (existing) {
      if (existing.paused) { pauseOthers(existing); btn.classList.add('is-playing'); existing.play().catch(function () {}); }
      else { existing.pause(); btn.classList.remove('is-playing'); }
      return;
    }
    pauseOthers(null);
    var video = document.createElement('video');
    video.className = 'gl-clients__video';
    video.src = src;
    video.controls = true;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.preload = 'auto';
    video.addEventListener('ended', function () { btn.classList.remove('is-playing'); });
    video.addEventListener('pause', function () { if (!video.ended) btn.classList.remove('is-playing'); });
    video.addEventListener('play', function () { btn.classList.add('is-playing'); });
    btn.appendChild(video);
    btn.classList.add('is-playing');
    video.play().catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-reel-play]');
    if (!btn) return;
    // si el clic cae sobre los controles nativos del <video>, no interceptar
    if (e.target.closest('.gl-clients__video')) return;
    e.preventDefault();
    play(btn);
  });
})();
